import classNames from 'classnames'
import { ReactNode } from 'react'

import style from './OrderStepContent.module.scss'

type OrderStepContentProps = {
  children: ReactNode
  className?: string
}

// обёртка для контента шага заявки (идёт после ProductOrderHeader)
export function OrderStepContent({
  children,
  className,
}: OrderStepContentProps) {
  return <div className={classNames(style.content, className)}>{children}</div>
}
